import { createPortal } from 'react-dom';

/* Fixed-position chrome — a dialog scrim, a context menu, a picker popover —
   has to hang off <body>. Every glass surface now carries the system's
   `backdrop-filter`, and a filtered element becomes the containing block for
   its fixed descendants, which would re-anchor the overlay to the panel it
   happened to be rendered inside instead of the viewport. */
export function Portal({ children }) {
  return createPortal(children, document.body);
}
